// extracted by mini-css-extract-plugin
export var dragHelperStyle = "hbo1R";